import { render, staticRenderFns } from "./WPLogo.vue?vue&type=template&id=1eef64ba"
import script from "./WPLogo.vue?vue&type=script&lang=ts"
export * from "./WPLogo.vue?vue&type=script&lang=ts"
import style0 from "./WPLogo.vue?vue&type=style&index=0&id=1eef64ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports